const Skill=()=>{
    const design=(
        <>
           <div className="container-fluid p-4  skill-box">
                    <div className="row">
                        <h2>Skills</h2>
                            <p>Quest to work & learn in a real professional world that enables me to cope with the emerging as well as latest technology and scope the widening the spectrum of my knowledge... <br /><br /> HTML|CSS|JavaScript| React|Bootstrap|MongoDB| <br />Express|Nodejs.</p>
                            <div className="row">
                            <div className="col-md-6">
                                <span className='float-start'>HTML</span>
                                <span className='float-end html'>95%</span>
                                <br />
                                <div className="progress mb-5">
                                <div className="progress-bar progress-html"></div>
                                </div>
                                <span className='float-start'>CSS</span>
                                <span className='float-end html'>75%</span>
                                <br />
                                <div className="progress mb-5">
                                <div className="progress-bar progress-css"></div>
                                </div>
                                <span className='float-start'>Java Script</span>
                                <span className='float-end html'>70%</span>
                                <br />
                                <div className="progress mb-5">
                                    <div className="progress-bar progress-js"></div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <span className='float-start'>React JS</span>
                                <span className='float-end html'>65%</span>
                                <br />
                                <div className="progress mb-5">
                                    <div className="progress-bar progress-react"></div>
                                </div>
                                <span className='float-start'>Node JS</span>
                                <span className='float-end html'>70%</span>
                                <br />
                                <div className="progress mb-5">
                                    <div className="progress-bar progress-node"></div>
                                </div>
                                <span className='float-start'>Mongo DB</span>
                                <span className='float-end html'>75%</span>
                                <br />
                                <div className="progress mb-5">
                                    <div className="progress-bar progress-mongo"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </>
    )
    return design;
}
export default Skill;